<template>
  <svg xmlns="http://www.w3.org/2000/svg" style="height: 0" viewBox="0 0 200 20">
    <defs>

    </defs>
  </svg>
</template>

<script>
export default {
  name: 'SvgPack'
}
</script>

